import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { QueryParams } from '@components/Filters/filter.types'

type BulkActionsState = {
  isModalOpen: boolean
} & {
  [K in keyof QueryParams]?: {
    selectedIds: Record<number, boolean>
    bulkActionName: string | null
  }
}

const initialBulkActionsState: BulkActionsState = {
  isModalOpen: false,
}

// TODO: remove bulk actions slice
const bulkActionsSlice = createSlice({
  name: 'bulkActions',
  initialState: initialBulkActionsState,
  reducers: {
    setSelectedIds: (
      state,
      action: PayloadAction<{
        area: keyof QueryParams
        selectedIds: Record<number, boolean>
      }>,
    ) => {
      const { area, selectedIds } = action.payload
      if (!state[area]) {
        state[area] = { selectedIds: {}, bulkActionName: null }
      }
      state[area]!.selectedIds = selectedIds
    },

    toggleSelectedId: (
      state,
      action: PayloadAction<{
        area: keyof QueryParams
        id: number
      }>,
    ) => {
      const { area, id } = action.payload
      if (!state[area]) {
        state[area] = { selectedIds: {}, bulkActionName: null }
      }

      const currentIds = state[area]!.selectedIds

      if (currentIds[id]) {
        delete state[area]!.selectedIds[id]
      } else {
        state[area]!.selectedIds[id] = true
      }
    },

    clearSelectedIds: (state, action: PayloadAction<keyof QueryParams>) => {
      const area = action.payload
      if (state[area]) {
        state[area]!.selectedIds = {}
      }
    },

    setModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload
    },

    setBulkActionName: (
      state,
      action: PayloadAction<{
        area: keyof QueryParams
        actionName: string | null
      }>,
    ) => {
      const { area, actionName } = action.payload
      if (!state[area]) {
        state[area] = { selectedIds: {}, bulkActionName: null }
      }
      state[area]!.bulkActionName = actionName
    },

    resetBulkActions: (state, action: PayloadAction<keyof QueryParams>) => {
      const area = action.payload
      if (state[area]) {
        state[area] = { selectedIds: {}, bulkActionName: null }
      }
    },
  },
})

export const bulkActionsReducer = bulkActionsSlice.reducer
